import React from 'react'
import styled from 'styled-components'
import envelopClock from 'assets/images/icons/envelop-clock.svg'


const Container = styled.div`
  text-align: center;
  margin-bottom: 20px;
`

const SpanIcon = styled.span`
  mask-image: url(${envelopClock});
  content: '';
  display: block;
  margin: 0 auto 10px;
  height: 55px;
  width: 55px;
  background-color: #2425aa;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: 50% 50%;
  mask-position: 50% 50%;
`

const WatingCheckingQrPayment = () => {
  return (
    <Container>
      <SpanIcon />
      <div>บริษัทอยู่ระหว่างการตรวจสอบการชำระเงิน</div>
      <div>หากตรวจสอบเรียบร้อย ระบบจะดำเนินการส่งใบรับเงินชั่วคราว</div>
      <div>ไปยังอีเมลของท่านโดยอัตโนมัติ</div>
      <div>กรุณากดปุ่ม “ถัดไป” เพื่อดำเนินการส่งใบคำขอ</div>
    </Container>
  )
}

export default (hoc) => hoc(WatingCheckingQrPayment)
